export const CHANGE_ID_CAMPAIGN_SERVICE_EDITOR = 'CHANGE_ID_CAMPAIGN_SERVICE_EDITOR';
export type CHANGE_ID_CAMPAIGN_SERVICE_EDITOR = typeof CHANGE_ID_CAMPAIGN_SERVICE_EDITOR;

export interface ChangeIdCampaignServiceEditor {
    type: CHANGE_ID_CAMPAIGN_SERVICE_EDITOR;
    editorId: string;
    serviceId: string;
}

export function changeIdCampaignServiceEditorAction(
    editorId: string,
    serviceId: string
): ChangeIdCampaignServiceEditor {
    return {
        type: CHANGE_ID_CAMPAIGN_SERVICE_EDITOR,
        editorId,
        serviceId
    };
}
